// assets
import Almendro from '../assets/almendro.jpg'

export default function Canalizacion() {
    return (
        <div className="container">
			<div className="theme-band"></div>
			<div className="article">
				<h1>Canalización</h1>
				<h2>CANALIZACIÓN</h2>
				<p>La canalización es una comunicación entre almas, es un acto de servicio y escucha desde el alma y para el alma.</p>
				<p>Si quieres escuchar a tu alma, a tus guías, a los seres que te acompañan permanentemente desde otros planos de conciencia, si quieres comunicarte con tus ancestros, te ofrezco el servicio de canalización.</p>
				<p>Disponible presencial y on line.</p>
				<br/>
				<h2>MENSAJES DEL SER</h2>
				<p>En estos tiempos en los que todo va muy rápido, en los que tenemos el día lleno de ocupaciones, apenas queda espacio para escucharnos, para sentirnos.</p>
				<p>Si quieres concederte un tiempo para tí, y no sabes por dónde empezar, te puedo acompañar con Mensajes del Ser, de tu SER.</p>
				<p>Con los mensajes canalizados para tí se elaborará un texto que se enviará por correo electrónico.</p>
				<br/>
				<p><strong>NOTA:</strong> En todos y cada uno de los servicios aquí detallados el trabajo que desarrollo no parte de mí, soy CANAL, soy guiada desde otros planos de conciencia por el Amor Incondicional.</p>
				<img src={Almendro} alt="Canalización" className="img-center" />
				<br/>
			</div>	
		</div>
    )
}
